<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-3 pt-0 pb-2 min-vh-50">
              <form id="search" class="mt-3 mr-2" @submit.prevent="getRFQ">
                <div class="row g-2 d-flex justify-content-end">
                  <div class="col-12 col-sm-2">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">RFQ Number / PO Number</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <input v-model="search.rfq_number" type="text" class="form-control" placeholder="RFQ Number" aria-label="RFQ Number" aria-describedby="basic-addon1">
                    </div>
                  </div>
                  <div class="col-12 col-sm-2">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">RFQ Date</label>
                    <Datepicker 
                      v-model="search.rfq_date" 
                      range
                      format="dd MMM yyyy"/>
                  </div>
                  <div class="col-12 col-sm-2">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Status</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <select v-model="search.state" class="form-select form-select-sm" >
                        <option v-for="(value, key) in statusOptions" :key="key" :value="key">{{ value }}</option>
                      </select>
                    </div>
                    
                  </div>
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Project</label>
                    <Multiselect
                      v-model="search.project_ids"
                      mode="tags"
                      label="name" 
                      track-by="name"
                      :close-on-select="false"
                      :searchable="true"
                      :options="options_projects"
                      :multiple="true" 
                      :taggable="true"
                      placeholder = "Project"
                    />
                  </div>
                  <div class="col-12 col-sm-2">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Vendor Forecast</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <input v-model="search.vendor_forecast" type="text" class="form-control" placeholder="Vendor Forecast ID" aria-label="Vendor Forecast ID" aria-describedby="basic-addon1">
                    </div>
                  </div>
                  <div class="col-12 col-sm-2 align-self-top pt-4 d-flex">
                    <button type="submit" class="btn btn-primary mb-0 justify-content-center" style="width: 50px;" @click="resetOffset">
                      <i class="fa fa-search"></i>
                    </button>

                    <!-- Adding margin to create space -->
                    <button class="btn btn-primary mb-0 justify-content-center" style="width: 50px; margin-left: 5px;" @click="clearSearch">
                      <i class="fa fa-times-circle"></i>
                    </button>

                  </div>
                </div>
              </form>
              <hr class="my-2"/>
              <div class="d-flex justify-content-end">
                <p class="align-self-center text-xs text-secondary">{{ current_page }} - {{ current_total_data }} / {{ total_data }}</p>
                <argon-pagination color="gradient-primary" size="sm">
                  <argon-pagination-item
                  @click="prevPage"
                    prev
                    :disabled="offset === 0 ? true : false" />
                  <argon-pagination-item
                    @click="nextPage"
                    next
                    :disabled="record_more === false ? true : false" />
                </argon-pagination>
              </div>
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="bg-light">
                      <th class="text-uppercase text-xxs font-weight-bolder">RFQ No.</th>
                      <th class="text-uppercase text-xxs font-weight-bolder">PO No.</th>
                      <th
                        class="text-uppercase text-xxs font-weight-bolder ps-2"
                      >Order Date</th>
                      <th
                        class="text-uppercase text-xxs font-weight-bolder ps-2"
                      >Receipt Date</th>
                      <th
                        class="text-uppercase text-xxs font-weight-bolder ps-2"
                      >Projects</th>
                      <th
                        class="text-uppercase text-xxs font-weight-bolder ps-2"
                      >Vendor Forecast</th>
                      <th
                        class="text-uppercase text-xxs font-weight-bolder ps-2"
                      >Status</th>
                      <th
                        class="text-uppercase text-xxs font-weight-bolder ps-2"
                      >Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="rfq in rfq_list" :key="rfq.id">
                      <td>
                          <router-link :to="'/rfq/' + rfq.id" class="text-xs text-primary font-weight-bold mb-0 ps-3">
                            {{ rfq.rfq_number === 'New' ? rfq.name : rfq.rfq_number }}
                          </router-link>
                      </td>
                      <td>
                          <router-link :to="'/rfq/' + rfq.id" class="text-xs text-primary font-weight-bold mb-0 ps-3">
                            {{ rfq.rfq_number === 'New' ? '-' : rfq.name }}
                          </router-link>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ rfq.date_order }}</p>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ rfq.date_planned }}</p>
                      </td>
                      <td>
                        <p class="text-sm mb-0 pl-1"><argon-badge style="margin-left: 2px;" v-for="project in rfq.project_ids" :key="project.id" 
                          color="secondary"
                          size="sm">{{ project.name }}
                        </argon-badge></p>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ rfq.vendor_forecast }}</p>
                      </td>
                      <td class="align-middle text-sm">
                        <!-- <argon-badge color="warning" class="align-self-center" v-if="rfq.state != 'Confirmed Supplier'" size="sm">Waiting Confirmation</argon-badge>
                        <argon-badge color="info" class="align-self-center" size="sm" v-else>{{ rfq.state }}</argon-badge> -->
                        <argon-badge class="align-self-center bg-primary text-white" size="sm" v-if="rfq.state == 'RFQ'">{{ rfq.state }}</argon-badge>
                        <argon-badge color="primary" class="align-self-center" size="sm" v-else-if="rfq.state == 'Submitted'">{{ rfq.state }}</argon-badge>
                        <argon-badge color="warning" class="align-self-center" size="sm" v-else>Waiting Confirmation</argon-badge>
                      </td>
                      <td class="align-middle">
                        <span class="text-secondary text-xs">{{ rfq.amount_total }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!rfq_list.length > 0 && !loading"/>
              <loading-state v-if="loading == true"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";
import EmptyState from "./components/EmptyState.vue";
import LoadingState from "./components/LoadingState.vue";
const endpoint = require("../router/endpoint");
export default {
    name: 'RFQ',
    components: {
      ArgonPagination,
      ArgonPaginationItem,
      ArgonBadge,
      EmptyState,
      LoadingState
    },
    data () {
      return {
        loading: false,
        total_data: 0,
        current_total_data: 0,
        current_page: 0,
        offset: 0,
        record_more: false,
        search: {
          rfq_number: null,
          vendor_forecast: null,
          state:null,
          rfq_date: [],
          project_ids: [],
        },
        rfq_list: [],
        options_projects: [],
        statusOptions: {
        'draft': 'RFQ',
        'confirm_supplier': 'Confirmed Supplier',
        'sent': 'RFQ Sent',
        'submit': 'Submitted',
        'checked': 'Confirmed',
        'to approve': 'To Approve',
        'approved_manager': 'Manager Approved',
        'approved_gm': 'GM/Dir. Approved'
      }
      }
    },
    methods: {
      prevPage() {
      if (this.offset > 0) {
          this.offset = this.offset - 10
          this.getRFQ()
        }
      },
      nextPage() {
        if (this.record_more === true) {
          this.offset = this.offset + 10
          this.getRFQ()
        }
      },
      getDate(daterange) {
      var dateList = []
      if (daterange !== null){
        if (daterange.length > 0) {
          daterange.forEach(date => {
            if (date) {
              let month = date.getMonth() >= 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
              let fullDate = date.getFullYear() + '-' + month + '-' + date.getDate()
              dateList.push(fullDate)
            }
          });
        }
      }
      return dateList
    },
      getRFQ() {
        this.loading = true
        this.rfq_list = []
        this.total_data = 0
        this.current_total_data = 0
        this.record_more = false
        this.current_page = 0
        let rfq_date = this.getDate(this.search.rfq_date)
        this.axios
        .post(
          endpoint.RFQ_LIST,
          {
            rfq_number: this.search.rfq_number,
            date_start: rfq_date.length > 0 ? rfq_date[0] : null,
            date_end: rfq_date.length > 1 ? rfq_date[1] : null,
            partner_id: localStorage.getItem('partner_id'),
            vendor_forecast: this.search.vendor_forecast,
            project_ids:this.search.project_ids,
            state:this.search.state,
            limit: 10,
            offset: this.offset
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.rfq_list = response.data.data;
            this.total_data = response.data.total_data
            this.current_total_data = response.data.current_total_data
            this.record_more = response.data.record_more
            this.current_page = response.data.current_page
            this.loading = false
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
            }
            this.loading = false
          }
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: e.response.data.message,
          });
          this.loading = false
        });
      },
      getProject() {
            this.loading = true
            this.options_projects = []
            this.axios
            .post(
                    endpoint.PROJECT_SEARCH,
                    {
                    }, //PARAMS
                    {
                        headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                )
                .then((response) => {
                    console.log(response)
                if (response.data.response_code === "0000") {
                    this.options_projects = response.data.data;
                } 
                else {
                    // sys error
                    if (response.data.response_code !== "4000"){
                        this.$notify({
                            type: 'error',
                            title: 'Warning',
                            text: response.data.message
                        });
                        this.loading = false
                    }
                }
                })
                .catch((e) => {
                    this.$notify({
                        type: 'error',
                        title: 'Failed',
                        text: e.response.data.message,
                    });
                    console.log(e)
                    this.loading = false
                });
        },
    clearSearch(){
          this.search.rfq_number = null;
          this.search.vendor_forecast = null;
          this.search.project_ids = [];
          this.search.state = null;
          this.search.rfq_date = [];
    },
    searchValue(array, key, value) {
        return array.filter(item => item[key] === value);
    },
    resetOffset(){
      this.offset = 0
    }
  },
    mounted() {
      this.getRFQ();
      this.getProject();
    }
}
</script>

<style>

</style>